import React, { useEffect, useState  } from 'react';
import swal from 'sweetalert2';
import noData from '../assets/images/no-data.png';
import { getScheduledClients, postTmerForm, sendLink } from './api/scheduledAPI';
import moment from 'moment';
import Select from 'react-select';
import * as helper from '../components/global/helper';

const Scheduled = () => {

    const [clients,             setClients]             = useState([]);
    const [filteredClients,     setFilteredClients]     = useState([]);
    const [client,              setClient]              = useState(null);
    const [clientId,            setClientId]            = useState(null);
    const [mobile,              setMobile]              = useState(null);
    const [validated,           setValidated]           = useState(false);
    const [formValidated,       setFormValidated]       = useState(false);
    const [data,                setData]                = useState({});
    const [countryCode,         setCountryCode]         = useState({ value: "+91", label: "India (+91)" });

    useEffect(() => {
        fetchClients();
        const formModalElement = document.getElementById('formModal'); 
        const linkModalElement = document.getElementById('sendLinkModal'); 
        const handleFormModalHide = () => resetData();
        const handleLinkModalHide = () => resetData();

        formModalElement.addEventListener('hidden.bs.modal', handleFormModalHide);
        linkModalElement.addEventListener('hidden.bs.modal', handleLinkModalHide);

        return () => {
            formModalElement.removeEventListener('hidden.bs.modal', handleFormModalHide);
            linkModalElement.removeEventListener('hidden.bs.modal', handleLinkModalHide);
        };    
    }, []);


    const fetchClients = async() => {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
            const { Clients } = await getScheduledClients();
            setClients(Clients);
            setFilteredClients(Clients)
            swal.close();
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const onClientSearch = (searchTerm) => {
        if(!searchTerm || searchTerm === '') return setFilteredClients(clients);

        //filter as per searched
        const filtered = clients.filter(m => {
            let matchString = `${m.Name} ${m?.Email} ${m.Contact1} ${m.Contact2} ${m.Language} ${m.City} ${m.State} ${m.Division} ${m.BranchCode}`;
            let matchFound  = 0;
            var searchArr   = searchTerm.split(' ');
            
            searchArr.forEach(t => matchFound += matchString.toLowerCase().includes(t.toLowerCase()) ? 1 : 0);

            return matchFound === searchArr.length;
        });
        
        setFilteredClients(filtered);
    };

    const joinCall = (m) => {
        //window.open(`http://localhost:3000/videocall?room=${m.RoomID}`, '_blank', 'noopener');
        window.open(`https://care.metromatrixonlineconsultation.com/videocall?room=${m.RoomID}`, '_blank', 'noopener');

    };

    const shareLink = (m) => {
        setClientId(m.ID);
        setMobile(m.Contact1);
        setCountryCode({ value: "+91", label: "India (+91)" })
        for (let i = 0; i < helper.countryCodes.length; i++) {
            const country = helper.countryCodes[i];
            if (m.Contact1.startsWith(country.value)) {
              setCountryCode({ value: country.value, label: country.label });
              setMobile(m.Contact1.slice(country.value.length));
            }
        }      
    };

    const viewForm = (m) => {
        setClient(m);  
    };

    const postShareLink = async(e)=> {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {     
            e.stopPropagation();
            setValidated(true);
        }else{
            try {
                swal.fire({
                    titleText           : 'Loading',
                    text                : 'Please Wait...',
                    showConfirmButton   : false,
                    allowOutsideClick   : false,
                    didOpen: () => {
                        swal.showLoading();
                    }
                });

                await sendLink(clientId, `${countryCode.value}${mobile}`);
                document.querySelector('#sendLinkModal .btn-close').click();
                swal.close();

                swal.fire({
                    icon: 'success',
                    title: '<small>Link sent successfully!</small>',
                    showConfirmButton: false,
                    timer: 1500,
                });


            } catch (err) {
                swal.close();
                swal.fire({
                    icon              : "error",
                    titleText         : "Error!",
                    text              : err.message
                  })
                return;  
            }
        }
    }

    const handleData = (key, value)=>{
        setData((d)=> { return {...d, [key] : value} });
    };

    const submitForm = async (e) => {
        e.preventDefault();

        const form = e.currentTarget;

        if (form.checkValidity() === false) {
            e.stopPropagation();
            setFormValidated(true);
            swal.fire({ icon: "warning", title: "<small>Please answer all the required questions</small>"});
        }else{

            try {   
                swal.fire({
                    titleText           : 'Loading',
                    text                : 'Please Wait...',
                    showConfirmButton   : false,
                    allowOutsideClick   : false,
                    didOpen: () => {
                        swal.showLoading();
                    }
                });

                const form = [];
                for (const item in data) {
                    form.push({
                        QuestionID  : item,
                        Answer      : item == 4 ? moment(data[item]).format('DD/MM/YYYY') : data[item]
                    })
                }

                await postTmerForm(client.ID, form);
                await fetchClients();
                document.querySelector('#formModal .btn-close').click();
                swal.close();

                swal.fire({
                    icon: 'success',
                    title: '<small>Form submitted successfully!</small>',
                    showConfirmButton: false,
                    timer: 1500,
                });
                
            } catch (err) {
                swal.close();
                swal.fire({ icon: "error", titleText: "Error!", text: err.message });
                return;  
            }
            
        }       

    };

    const resetData = () => {
        setClientId(null);
        setClient(null);
        setMobile(null);
        setData({});
        setValidated(false);
        setFormValidated(false);  
        setCountryCode({ value: "+91", label: "India (+91)" })
    };

    return ( 
        <>
            <div className="navbar navbar-expand-lg fixed-top margin-t58" style={{backgroundColor: '#fff', zIndex: '1'}}>
                <div className="container d-block padding-t10" style={{height: '60px'}}>
                    <div className='row mb-4'>
                        <div className='col-12'>
                            <div className='input-group'>
                                <span className='input-group-text fs-16'><i className="bi bi-search"></i></span>
                                <input 
                                    className="form-control fs-16" 
                                    type="search" 
                                    placeholder="Search"
                                    onChange={({target}) => onClientSearch(target.value)}
                                />
                            </div>
                        </div>              
                    </div>
                </div>
            </div>

            <div className='container margin-t150'>  
                <div className='row'>
                    <div className='col-12 d-none d-lg-block'>
                        {filteredClients.length > 0 ? filteredClients.map((m, i) => (
                            <div key={m.ID} className="card border-light mb-4 p-2" style={{backgroundColor: '#eff3f7', borderRadius: '18px'}}>
                                <div className="card-body d-flex justify-content-between align-items-center">
                                    <div>
                                        <h6 className="card-title">{m.Name}</h6>
                                        <span className='card-text fs-16'>
                                            <span>{m.Age ? `Age: ${m.Age} | ` : ''}Contact: {m.Contact1}{m.Contact2 ? `, ${m.Contact2}` : ''}{m.City ? ` | City: ${m.City}` : ''}{m.State ? ` | State: ${m.State}` : ''}</span><br></br>
                                            <span>{m.Language ? `Language: ${m.Language}` : ''}{m.SumAssured ? `${m.Language ? ' | ' : ''}Sum Assured: ${m.SumAssured}` : ''}</span>
                                        </span>
                                        <div className='mt-2'>
                                            <span className='fs-14 fw-semibold' style={{color:'#767676'}}><i className="bi bi-clock-fill me-2" style={{color:'#4582ec'}}></i>{moment(m.Date).format('DD MMM')} {m.From} - {m.To}</span>
                                        </div>
                                    </div>
                                    <div>
                                        <span className={`badge bg-${m.TestType == 'VMER' ? 'primary' : 'info'} me-3`}>{m.TestType}</span>
                                        {m.TestType == 'TMER' ? (
                                            <button onClick={() => viewForm(m)} data-bs-toggle="modal" data-bs-target="#formModal" type="button" className="btn btn-outline-primary"><i className="bi bi-ui-checks me-2"></i>View Form</button>
                                        ) : (
                                            <>
                                                <button onClick={() => joinCall(m)} type="button" className="btn btn-outline-primary me-2"><i className="bi bi-camera-video me-2"></i>Join</button>
                                                <button onClick={() => shareLink(m)} data-bs-toggle="modal" data-bs-target="#sendLinkModal" type="button" className="btn btn-outline-info"><i className="bi bi-whatsapp me-2"></i>Share</button>
                                            </>
                                        )}   
                                    </div>
                                </div>
                            </div>
                        )) : (
                            <div className='text-center mt-5'>
                                <img src={noData} alt="image"  height="200"/>
                                <h5 className='mt-3'>No Scheduled Clients!</h5>
                            </div>
                        )}
                        
                    </div>

                    <div className='col-12 d-lg-none'> 
                        {filteredClients.length > 0 ? filteredClients.map((m, i) => (
                            <div key={m.ID} className="card border-light mb-4 mx-1 p-2" style={{backgroundColor: '#eff3f7', borderRadius: '18px'}}>
                                <div className="card-body">
                                    <h6 className="card-title">{m.Name}</h6>
                                    <span className='card-text fs-16'>
                                        <span>{m.Age ? `Age: ${m.Age} | ` : ''}Contact: {m.Contact1}{m.Contact2 ? `, ${m.Contact2}` : ''}</span><br></br>
                                        <span>{m.City ? `City: ${m.City}` : ''}{m.State ? `${m.City ? ' | ' : ''}State: ${m.State}` : ''}</span><br></br>
                                        <span>{m.Language ? `Language: ${m.Language}` : ''}{m.SumAssured ? `${m.Language ? ' | ' : ''}Sum Assured: ${m.SumAssured}` : ''}</span>
                                    </span><br></br>
                                    <div className='mt-4 mb-2'>
                                        <span className={`badge bg-${m.TestType == 'VMER' ? 'primary' : 'info'} me-2`}>{m.TestType}</span>
                                        {m.TestType == 'TMER' ? (
                                            <button onClick={() => viewForm(m)} data-bs-toggle="modal" data-bs-target="#formModal" type="button" className="btn btn-outline-primary"><i className="bi bi-ui-checks me-2"></i>View Form</button>      
                                        ) : (
                                            <>
                                                <button onClick={() => joinCall(m)} type="button" className="btn btn-outline-primary me-2"><i className="bi bi-camera-video me-2"></i>Join</button>
                                                <button onClick={() => shareLink(m)} data-bs-toggle="modal" data-bs-target="#sendLinkModal" type="button" className="btn btn-outline-info"><i className="bi bi-whatsapp me-2"></i>Share</button>
                                            </>
                                        )}                                       
                                    </div>                          
                                </div>
                                <div className="card-footer fs-16" style={{backgroundColor: '#eff3f7'}}>
                                    <span className='fs-14 fw-semibold' style={{color:'#767676'}}><i className="bi bi-clock-fill me-2" style={{color:'#4582ec'}}></i>{moment(m.Date, 'YYYY-MM-DD').format('DD MMM')} {m.From} - {m.To}</span>
                                </div>
                            </div>
                        )) : (
                            <div className='text-center mt-5'>
                                <img src={noData} alt="image"  height="200"/>
                                <h5 className='mt-3'>No Scheduled Clients!</h5>
                            </div>
                        )}

                    </div>
                </div>
            </div>

            <div id='sendLinkModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">Send Link</h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <form id='shareLinkForm' className={`row mt-3 needs-validation ${validated ? "was-validated" : ""}`} noValidate onSubmit={postShareLink}>
                                    <div className='row'>
                                        <div className='col-12 mb-3'>
                                            <Select
                                                value={countryCode}
                                                onChange={(e) => setCountryCode({value: e.value, label: e.label})}
                                                options={helper.countryCodes}
                                            />
                                        </div>
                                        <div className='col-12 mb-3'>
                                            <input
                                                onChange={({ target }) => setMobile(helper.contact(target.value))}
                                                value={mobile || ''}
                                                id="txtMobile" 
                                                type="text"  
                                                className="form-control"
                                                placeholder="Mobile"
                                                required
                                            />
                                            <div className="invalid-feedback">Please enter mobile no.</div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="submit" form='shareLinkForm' className="btn btn-success"><i className="bi bi-whatsapp me-2"></i>Whatsapp</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id='formModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">Medical Form</h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <form id='medicalForm' className={`row needs-validation ${formValidated ? "was-validated" : ""}`} noValidate onSubmit={submitForm}>
                                    {client && (
                                        <div className='col-md-12 text-center'>
                                            <h5>{client.Name}</h5>
                                            <span className="col-form-label mb-2">Proposal No: {client.ProposalNo} | Branch Code: {client.BranchCode}</span><br></br>
                                            <span className="col-form-label mb-2">{moment().format('DD MMMM hh:mm A')}</span>
                                        </div>
                                    )}

                                    <div className='col-md-12 mt-4 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-2">Identity Proof</label>
                                            <div className="form-check mb-2">
                                                <input
                                                    className="form-check-input" 
                                                    type="radio"  
                                                    value="Aadhar Card"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleData('1', target.value)}
                                                    checked={data['1'] === 'Aadhar Card'}
                                                    required
                                                />
                                                <label className="form-check-label">
                                                    Aadhar Card
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="PAN Card"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleData('1', target.value)}
                                                    checked={data['1'] === 'PAN Card'}
                                                />
                                                <label className="form-check-label">
                                                    PAN Card
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="Driving Licence"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleData('1', target.value)}
                                                    checked={data['1'] === 'Driving Licence'}
                                                />
                                                <label className="form-check-label">
                                                    Driving Licence
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="Passport"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleData('1', target.value)}
                                                    checked={data['1'] === 'Passport'}
                                                />
                                                <label className="form-check-label">
                                                    Passport
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="Employee ID"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleData('1', target.value)}
                                                    checked={data['1'] === 'Passport'}
                                                />
                                                <label className="form-check-label">
                                                    Employee ID
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    value="Voter ID"
                                                    name="identityProof"
                                                    onChange={({ target }) => handleData('1', target.value)}
                                                    checked={data['1'] === 'Voter ID'}
                                                />
                                                <label className="form-check-label">
                                                    Voter ID
                                                </label>
                                            </div>
                                        </fieldset>            
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">ID Proof Number (in case of Aadhar only last 4 digits)</label>
                                        <input 
                                            onChange={({ target }) => handleData('2', target.value)}
                                            value={ data['2'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer" 
                                            required
                                        />
                                        <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Full name of the life to be assured</label>
                                        <input
                                            onChange={({ target }) => handleData('3', target.value)}
                                            value={ data['3'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Date of Birth</label>
                                        <input
                                            onChange={({ target }) => handleData('4', target.value)}
                                            value={ data['4'] || ''}
                                            type="date" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Age</label>
                                        <input
                                            onChange={({ target }) => handleData('5', target.value)}
                                            value={ data['5'] || ''}
                                            type="number" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-2">Gender</label>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="gander" 
                                                    value="Male"
                                                    onChange={({ target }) => handleData('6', target.value)}
                                                    checked={data['6'] === 'Male'}
                                                    required
                                                />
                                                <label className="form-check-label">
                                                    Male
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="gander" 
                                                    value="Female"
                                                    onChange={({ target }) => handleData('6', target.value)}
                                                    checked={data['6'] === 'Female'}
                                                />
                                                <label className="form-check-label">
                                                    Female
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="gander"  
                                                    value="Prefer not to say"
                                                    onChange={({ target }) => handleData('6', target.value)}
                                                    checked={data['6'] === 'Prefer not to say'}
                                                />
                                                <label className="form-check-label">
                                                    Prefer not to say
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="gander" 
                                                    value="Others"
                                                    onChange={({ target }) => handleData('6', target.value)}
                                                    checked={data['6'] === 'Others'}
                                                />
                                                <label className="form-check-label">
                                                    Others
                                                </label>
                                            </div>
                                        </fieldset>              
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Height (in cms)</label>
                                        <input
                                            onChange={({ target }) => handleData('7', target.value)}
                                            value={ data['7'] || ''}
                                            type="number" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Weight (in kgs)</label>
                                        <input
                                            onChange={({ target }) => handleData('8', target.value)}
                                            value={ data['8'] || ''}
                                            type="number" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether receiving or ever received any treatment/medication including alternate medicine like ayurveda, homeopathy etc</label>
                                        <input
                                            onChange={({ target }) => handleData('9', target.value)}
                                            value={ data['9'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Undergone any surgery / hospitalized for any medicalcondition / disability / injury due to accident ?</label>
                                        <input
                                            onChange={({ target }) => handleData('10', target.value)}
                                            value={ data['10'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether visited the doctor any time in the last 5 years ? If answer to any of the questions 5(a) to (c) is yes -i. Date of surgery/accident/injury/hospitalisationii. Nature and causeiii.Name of Medicineiv.Degree of impairment if anyv. Whether unconscious due to accident, if yes, give duration</label>
                                        <input
                                            onChange={({ target }) => handleData('11', target.value)}
                                            value={ data['11'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">In the last 5 years, if advised to undergo an X-ray/ CT scan / MRI /ECG / TMT / Blood test / Sputum/Throat swab test or any otherinvestigatory or diagnostic tests ? Please specify date , reason ,advised by whom & findings.</label>
                                        <input
                                            onChange={({ target }) => handleData('12', target.value)}
                                            value={ data['12'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from Novel Coronavirus (Covid-19) orexperienced any of the symptoms (for more than 5 days) such asany fever, Cough, Shortness of breath, Malaise (flu-like tiredness),Rhinorrhea (mucus discharge from the nose), Sore throat, Gastrointestinalsymptoms such as nausea, vomiting and/or diarrhoea,Chills, Repeated shaking with chills, Muscle pain, Headache, Loss oftaste or smell within last 14 days. If yes provide all investigation and treatment reports</label>
                                        <input
                                            onChange={({ target }) => handleData('13', target.value)}
                                            value={ data['13'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering from Hypertension (high blood pressure) or diabetes or blood sugar levels higher than normal or history of sugar /albuminin urine ?</label>
                                        <input 
                                            onChange={({ target }) => handleData('14', target.value)}
                                            value={ data['14'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Since when, any follow up and date and value of last checked blood pressure and sugar levels ?</label>
                                        <input 
                                            onChange={({ target }) => handleData('15', target.value)}
                                            value={ data['15'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether on medication ? please give name of the prescribed medicine and dosage</label>
                                        <input 
                                            onChange={({ target }) => handleData('16', target.value)}
                                            value={ data['16'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether developed any complications due to diabetes ?</label>
                                        <input 
                                            onChange={({ target }) => handleData('17', target.value)}
                                            value={ data['17'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether suffering from any other endocrine disorders such asthyroid disorder etc.?</label>
                                        <input 
                                            onChange={({ target }) => handleData('18', target.value)}
                                            value={ data['18'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Any weight gain or weight loss in last 12 months (other than by dietcontrol or exercise) ?</label>
                                        <input 
                                            onChange={({ target }) => handleData('19', target.value)}
                                            value={ data['19'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Any history of chest pain, heartattack, palpitations andbreathlessness on exertion or irregular heartbeat ?</label>
                                        <input 
                                            onChange={({ target }) => handleData('20', target.value)}
                                            value={ data['20'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether suffering from high cholesterol ?</label>
                                        <input 
                                            onChange={({ target }) => handleData('21', target.value)}
                                            value={ data['21'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whetheron medication for any heart ailment/ high cholesterol?Please state name of the prescribed medicine and dosage</label>
                                        <input 
                                            onChange={({ target }) => handleData('22', target.value)}
                                            value={ data['22'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether undergone Surgery such as CABG, open heart surgeryor PTCA ?</label>
                                        <input 
                                            onChange={({ target }) => handleData('23', target.value)}
                                            value={ data['23'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from any disease related to kidney suchas kidney failure, kidney or ureteral stones, blood or pus in urine orprostate ?</label>
                                        <input
                                            onChange={({ target }) => handleData('24', target.value)}
                                            value={ data['24'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from any Liver disorders like cirrhosis,hepatitis, jaundice, or disorder of the Spleen or from any lungrelated or respiratory disorders such as Asthma, bronchitis,wheezing, tuberculosis breathing difficulties etc.?</label>
                                        <input 
                                            onChange={({ target }) => handleData('25', target.value)}
                                            value={ data['25'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from any Blood disorder likeanaemia, thalassemia or any Circulatory disorder ?</label>
                                        <input
                                            onChange={({ target }) => handleData('26', target.value)}
                                            value={ data['26'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from any form of cancer, leukaemia,tumor, cyst or growth of any kind or enlarged lymph nodes ?</label>
                                        <input 
                                            onChange={({ target }) => handleData('27', target.value)}
                                            value={ data['27'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from Epilepsy, nervous disorder,multiple sclerosis, tremors, numbness, paralysis, brain stroke ?</label>
                                        <input 
                                            onChange={({ target }) => handleData('28', target.value)}
                                            value={ data['28'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from any physical impairment/disability /amputation or any congenital disease/abnormality ordisorder of back, neck, muscle, joints, bones, arthritis or gout ?</label>
                                        <input 
                                            onChange={({ target }) => handleData('29', target.value)}
                                            value={ data['29'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Suffering or ever suffered from Hernia or disorder of theStomach / intestines, colitis, indigestion, Peptic ulcer, piles, or anyother disease of the gall bladder or pancreas ?</label>
                                        <input 
                                            onChange={({ target }) => handleData('30', target.value)}
                                            value={ data['30'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">a. Suffering from Depression/Stress/ Anxiety/ Psychosis or any otherMental / psychiatric disorder? b. Whether on treatment or ever taken any treatment, if yes, pleasegive details of treatment, prescribed medicine and dosages</label>
                                        <input
                                            onChange={({ target }) => handleData('31', target.value)}
                                            value={ data['31'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Is there any abnormality of Eyes (partial/total blindness),Ears(deafness/ discharge from the ears), Nose, Throat orMouth, teeth, swelling of gums / tongue, tobacco stains or signs oforal cancer ?</label>
                                        <input
                                            onChange={({ target }) => handleData('32', target.value)}
                                            value={ data['32'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether person being examined and/ or his/her spouse/partnertested positive or is/ are under treatment for HIV/AIDS/Sexually transmitted diseases (e.g. syphilis, gonorrhea, etc.)</label>
                                        <input
                                            onChange={({ target }) => handleData('33', target.value)}
                                            value={ data['33'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Ascertain if any other condition / disease / adverse habit (such assmoking/ tobacco chewing/ consumption ofalcohol/drugs etc) which is relevant in assessent of medical risk ofexaminee. (Type No, If Yes mention details)</label>
                                        <input
                                            onChange={({ target }) => handleData('34', target.value)}
                                            value={ data['34'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">For Female: Whether pregnant? If so duration</label>
                                        <input
                                            onChange={({ target }) => handleData('35', target.value)}
                                            value={ data['35'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">For Female: Suffering from any pregnancy related complications</label>
                                        <input
                                            onChange={({ target }) => handleData('36', target.value)}
                                            value={ data['36'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Whether consulted a gynaecologist or undergone any investigation,treatment for any gynaec ailment such as fibroid, cyst or any diseaseof the breasts, uterus, cervix or ovaries etc. or taken / taking anytreatment for the same</label>
                                        <input
                                            onChange={({ target }) => handleData('37', target.value)}
                                            value={ data['37'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <fieldset>
                                            <label className="col-form-label mb-2">FROM MEDICAL EXAMINER’S OBSERVATION/ASSESSMENT WHETHER LIFE TO BE ASSURED APPEARS MENTALLY ANDPHYSICALLY HEALTHY</label>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="examiner" 
                                                    value="Yes"
                                                    onChange={({ target }) => handleData('38', target.value)}
                                                    checked={data['38'] === 'Yes'}
                                                />
                                                <label className="form-check-label" >
                                                    Yes
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="examiner" 
                                                    value="No"
                                                    onChange={({ target }) => handleData('38', target.value)}
                                                    checked={data['38'] === 'No'}
                                                />
                                                <label className="form-check-label">
                                                    No
                                                </label>
                                            </div>
                                        </fieldset>              
                                    </div>

                                    <div className='col-md-12 mb-4'>
                                        <label className="col-form-label">Place</label>
                                        <input
                                            onChange={({ target }) => handleData('39', target.value)}
                                            value={ data['39'] || ''}
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Your answer"
                                            required
                                        />
                                            <div className="invalid-feedback">This is a required question</div>
                                    </div>

                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="submit" form='medicalForm' className="btn btn-success">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
    

}

export default Scheduled;